export default {
  zh: {
    newRegister: '新用户注册',
    emailRegister: '邮箱注册',
    phoneRegister: '手机注册',
    haveAccount: '已有账号？前往',
    signIn: '登录'
  },
  en: {
    newRegister: 'New to PlexVPN',
    emailRegister: 'Email',
    phoneRegister: 'Phone',
    haveAccount: 'Already have an account? ',
    signIn: 'Sign In'
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/register/lang.js